<template>
  <div class="feedback-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="searchInfo.search"
            placeholder="输入服务名称或代码"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <!-- <el-input
            v-model="searchInfo.code"
            placeholder="输入代码"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input> -->
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>

        <div class="right">
          <!-- <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('addServiceType')"
            v-hasPermi="['服务类型管理', '新增']"
            >新增</el-button
          > -->
          <!--  <el-button
            type="primary"
            style="margin-left: 16px"
            @click="toggleSelection()"
            v-hasPermi="['用户反馈', '批量选择']"
            >批量选择</el-button
          >
          <el-button
            type="danger"
            style="margin-left: 16px"
            :disabled="multipleSelection.length === 0"
            @click="deleteSelection()"
            v-hasPermi="['用户反馈', '删除']"
            >删除</el-button
          > -->
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="服务类型名称" align="center">
        </el-table-column>
        <el-table-column prop="code" label="编码" align="center">
        </el-table-column>
        <el-table-column prop="amount" label="定价(元/年)" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                v-hasPermi="['服务类型管理', '详情']"
                @click="readClick(scope.row.id, 'detail')"
                >查看</span
              >
              <span
                class="btn read"
                v-hasPermi="['服务类型管理', '编辑']"
                @click="readClick(scope.row.id, 'edit')"
                >编辑</span
              >
              <!-- <span
                class="btn read"
                @click="deleteClick(scope.row.id)"
                v-hasPermi="['服务类型管理', '删除']"
                >删除</span
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.page"
          :page-size="table.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { getServiceTypeList, deleteServiceType } from '@/api/serviceType';
export default {
  data() {
    return {
      loading: false,
      table: {
        data: [],
        height: 100,
        page: 1,
        pageSize: 50,
        total: 0,
      },
      multipleSelection: [],
      searchInfo: {
        search: '',
      },
    };
  },
  created() {
    // this.getSortData()
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    //获取数据
    getData() {
      let params = {
        search: this.searchInfo.search,
        page: this.table.page,
        pageSize: this.table.pageSize,
      };
      getServiceTypeList(params).then((da) => {
        this.table.data = da.data.content;
        this.table.total = da.data.total;
      });
    },
    toggleSelection() {
      // this.table.data.forEach(row => {
      if (this.multipleSelection.length === this.table.total) {
        return;
      } else {
        this.$refs.multipleTable.toggleAllSelection();
        this.multipleSelection = this.table;
      }
      // });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.table.page = 1;
      this.getData();
    },
    currentChange() {
      this.getData();
    },
    handleSizeChange(e) {
      this.table.page = 1;
      this.table.pageSize = e;
      this.getData();
    },
    deleteClick(id) {
      MessageBox.confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteServiceType(id).then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功!');
            this.refresh();
          }
        });
      });
    },

    readClick(id, type) {
      this.$router.push({
        name: 'editServiceType',
        query: { id: id, type: type },
      });
    },

    // deleteSelection() {
    //   MessageBox.confirm('确认删除?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   }).then(() => {
    //     let params = [];
    //     this.multipleSelection.map((item) => {
    //       params.push(item.id);
    //     });
    //     delFeedBack({ ids: params.join(',') }).then((res) => {
    //       if (res.code == 0) {
    //         this.$message.success('删除成功!');
    //         this.refresh();
    //       }
    //     });
    //   });
    // },
    refresh() {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.feedback-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.feedback-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
